export enum DEBUGGER_TAB_KEYS {
  SCHEMA_TAB = "SCHEMA_TAB",
  RESPONSE_TAB = "RESPONSE_TAB",
  HEADER_TAB = "HEADERS_TAB",
  ERROR_TAB = "ERROR_TAB",
  LOGS_TAB = "LOGS_TAB",
  INSPECT_TAB = "INSPECT_TAB",
}
